import tradeData from './trade-data';

export default {
  tradeData,
};
